"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("circle", { cx: "32.16", cy: "17.52", r: "3" }),
  React.createElement("path", { d: "M44 6H4a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-2 22.8c-2.149-1.269-3.146-2.4-5.018-2.4-3.526 0-6.572 4.8-10.1 4.8s-8.015-9.6-11.542-9.6C12.136 21.6 6 31.2 6 31.2V10h36z" })
);

